<template>
  <div>
    <v-toolbar
      dark
      app
      :color="$root.themeColor">
      <v-toolbar-title>
        <v-toolbar-side-icon @click="toggleNavigationBar"></v-toolbar-side-icon>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      {{this.$store.getters.get_branch}}
      <v-menu class="toolbar-menu-item" offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator" :ripple="false">
          
          <v-avatar size="42px">
            <img src="@/assets/pngwave.png"/>
          </v-avatar>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item,index) in items"
            :key="index"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            @click="item.click">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title>
            Change Your Password
          </v-card-title>
          <v-container>            
            <v-text-field                    
               label="New Password"
               v-model="n_password"/>          
            <v-text-field                    
              label="Confirm New Password"
              v-model="c_password"/>   
          </v-container>
          <v-card-actions>
            <v-btn variant="outlined" @click="chn_pass()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      rating: null,
      dialog: false,
      dialogSettings: false,
      n_password : '',
      c_password : '',
      switchEmailNotification: true,
      showPassword: null,
      showPasswordConfirm: null,
      userEmail: null,
      password: null,
      passwordConfirm: null,
      error: false,
      showResult: false,
      result: '',
      items: [
      {
          icon: 'settings',
          href: '#',
          title: 'Change password',
          click: () => {            
            this.n_password = ''
            this.c_password = ''
            this.dialog = true
          },
        },
        {          
          icon: 'exit_to_app',
          href: '#',
          title: 'Log Out',
          click: () => {
            const vm = this;

            vm.$router.push({ name: 'Login' });
          }        
        },
      ],

    }
  },

  computed: {
    selectedLanguageFlag() {
      const vm = this;
    }
  },
  methods: {
    toggleNavigationBar() {
      const vm = this;

      vm.$emit('toggleNavigationBar');
    },

    chn_pass(){
      //console.log( this.n_password+'  '+this.c_password )
      if ( this.n_password === this.c_password  ){
          const vm = this;
          vm.axios.get("https://ws.plantifulbkk.shop/post_change_password.php",{
              params: {
                  scode: this.$store.getters.get_branch ,     
                  spass: this.n_password ,              
              }
          }).then(result=>{                  
                  alert("Change Password successfully ");
              })
          .catch(function (error) {
                  alert("Error")
                  console.log(error)
              })

          this.dialog = false
        }else{

          alert("Password not match??")
        }
},

    setUpSettings() {
      const vm = this;

      if (vm.userEmail === null || vm.password === null || vm.passwordConfirm === null) {

        vm.result = "Email and Password can't be null.";
        vm.showResult = true;

        return;
      }

      if (vm.password !== vm.passwordConfirm) {

        vm.error = true;
        vm.result = "Passwords does not match the confirm password.";
        vm.showResult = true;

        return;
      }

      vm.$root.userEmail = vm.userEmail;
      vm.$root.userPassword = vm.password;

      vm.result = "Email and password changed succesfully.";
      vm.showResult = true;

      vm.dialogSettings = false;
    },

    selectLanguage(code) {
      const vm = this;

      vm.$root.setLanguage(code);
    }
  }
};
</script>
<style>
  .toolbar-menu-item {
    padding-left: 5px;
  }

  .selected-language-flag {
    max-width: 45px;
  }

  .language-flag {
    max-width: 40px;
  }


  .languages-list-item {
    cursor: pointer;
    margin-top: -2px;
    margin-left: 1px;
  }

  .languages-list-item-title {
    font-size: 16px;
  }

  .languages-list-item-title:hover {
    color: #41B883;
    font-weight: bold;
  }
  .language-menu {
    border-radius: 25px;
    width: 235px;
    margin-right: 10px;
  }
  
  
</style>


// WEBPACK FOOTER //
// src/components/core/Toolbar.vue